import {ReactComponent as Logo} from '#/components/icons/logo-shareland.svg';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {Link} from 'react-router-dom';

export const ShareLandLogoLink = () => (
  <Link className='text-white flex items-center pointer-events-auto' to={ExchangeRoute.HOME}>
    <Logo className='mb-[2px] pointer-events-auto w-20 sm:w-28' />
  </Link>
);
